import { ref } from 'vue';

// A deliberately simple horizontal-swipe detector — not a general gesture
// library. Requires the swipe to travel further horizontally than
// vertically (by SLOPE_RATIO) so a normal vertical scroll on the same
// panel never gets misread as a tab change, and a MIN_DISTANCE floor so a
// stray tap doesn't fire either. New to v4 (no swipe gesture exists in the
// design itself) — added per direct request for the mobile Assessment /
// Identity / Records tab switcher, not a design-fidelity restoration.
const MIN_DISTANCE = 48;
const SLOPE_RATIO = 1.5;

export function useSwipeNavigation(onSwipeLeft: () => void, onSwipeRight: () => void) {
  const startX = ref(0);
  const startY = ref(0);

  function onTouchStart(e: TouchEvent) {
    startX.value = e.touches[0].clientX;
    startY.value = e.touches[0].clientY;
  }

  function onTouchEnd(e: TouchEvent) {
    const dx = e.changedTouches[0].clientX - startX.value;
    const dy = e.changedTouches[0].clientY - startY.value;
    if (Math.abs(dx) < MIN_DISTANCE || Math.abs(dx) < Math.abs(dy) * SLOPE_RATIO) return;
    if (dx < 0) {
      onSwipeLeft();
    } else {
      onSwipeRight();
    }
  }

  return { onTouchStart, onTouchEnd };
}
